// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { SimpleUser, ISimpleUser, OmniUser, IOmniUser, OrgMember, IOrgMember, OptionValueString, IOptionValueString, UserRoleClaim, IUserRoleClaim, NewUserWithOrganization, INewUserWithOrganization, AcceptedTerms, IAcceptedTerms, UserUpdate, IUserUpdate } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getAllUsers(): ApiResult<SimpleUser[]> {
	return get<ISimpleUser[]>(`/api/user`).then(result => result === undefined ? undefined : result.map(o => new SimpleUser(o)));
}

export async function getOrgUsers(orgId?: string): ApiResult<OmniUser[]> {
	return get<IOmniUser[]>(`/api/user/organization/${ orgId }`).then(result => result === undefined ? undefined : result.map(o => new OmniUser(o)));
}

export async function getOrgMembers(orgId?: string): ApiResult<OrgMember[]> {
	return get<IOrgMember[]>(`/api/user/organization/${ orgId }/members`).then(result => result === undefined ? undefined : result.map(o => new OrgMember(o)));
}

export async function getUsers(orgId?: string, facId?: string): ApiResult<OmniUser[]> {
	return get<IOmniUser[]>(`/api/user/organization/${ orgId }/location/${ facId }`).then(result => result === undefined ? undefined : result.map(o => new OmniUser(o)));
}

export async function makeSuperUser(userId?: string): ApiResult<undefined> {
	return post(`/api/user/${ userId }/super`);
}

export async function removeSuperUser(userId?: string): ApiResult<undefined> {
	return del(`/api/user/${ userId }/super`);
}

export async function saveUserOrganizationRoles(userId?: string, orgId?: string, roleNames?: string[]): ApiResult<undefined> {
	return post(`/api/user/${ userId }/save-roles-for-organization/${ orgId }`, roleNames);
}

export async function saveUserFacilityRoles(userId?: string, facId?: string, roleNames?: string[]): ApiResult<undefined> {
	return post(`/api/user/${ userId }/save-roles-for-facility/${ facId }`, roleNames);
}

export async function getAllRoles(): ApiResult<OptionValueString[]> {
	return get<IOptionValueString[]>(`/api/user/role-options`).then(result => result === undefined ? undefined : result.map(o => new OptionValueString(o)));
}

export async function getUser(userId?: string): ApiResult<OmniUser> {
	return get<IOmniUser>(`/api/user/${ userId }`).then(result => result === undefined ? undefined :  new OmniUser(result));
}

export async function getCurrentUserRoleClaims(): ApiResult<UserRoleClaim[]> {
	return get<IUserRoleClaim[]>(`/api/user/user-role-claims`).then(result => result === undefined ? undefined : result.map(o => new UserRoleClaim(o)));
}

export async function setLastViewedOrganizationId(orgId?: string): ApiResult<undefined> {
	return post(`/api/user/last-viewed-orgid`, orgId);
}

export async function createUser(newUser: NewUserWithOrganization): ApiResult<string> {
	return post<string>(`/api/user`, newUser);
}

export async function acceptTerms(userId?: string, acceptedTerms?: AcceptedTerms): ApiResult<undefined> {
	return post(`/api/user/${ userId }/accepted-terms`, acceptedTerms);
}

export async function updateUser(userUpdate: UserUpdate): ApiResult<undefined> {
	return post(`/api/user/update-user`, userUpdate);
}
